import { XMarkIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';
import type { ReactNode } from 'react';

export type PillTypes = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

const PillClasses = {
  success: 'bg-success-subtle text-success ring-success/20',
  // 950, not 800: on `warning-subtle` (#f9f1e1) the 800 step measures 3.43:1
  // and 900 only 4.24:1, both short of WCAG AA for small text. 950 is 5.42:1.
  warning: 'bg-warning-subtle text-warning-950 ring-warning/20',
  danger: 'bg-danger-subtle text-danger ring-danger/20',
  info: 'bg-info-subtle text-info ring-info/20',
  neutral: 'bg-grey-900 text-grey-100 ring-grey-700/20',
};

const baseStyle =
  'inline-flex rounded-pill text-center px-3 py-1 text-sm font-medium ring-1 ring-inset';

export const ExpiredPill = ({ cyTag }: { cyTag: string }) => {
  return (
    <span data-cy={cyTag} className={classNames(baseStyle, PillClasses.danger)}>
      <XMarkIcon className="my-auto size-3 stroke-2" />
      <span className="pl-2">Expired</span>
    </span>
  );
};

export const Pill = ({
  label,
  customStyle,
  cyTag,
  type,
  icon,
}: {
  label: string;
  customStyle?: string;
  cyTag?: string;
  type?: PillTypes;
  // Shown before the label so a status never depends on its color alone.
  icon?: ReactNode;
}) => {
  return (
    <span
      data-cy={cyTag}
      className={classNames(
        baseStyle,
        customStyle,
        type && PillClasses[type],
        'items-center justify-center',
        icon ? 'gap-1' : undefined
      )}
    >
      {icon}
      {label}
    </span>
  );
};
